var data = {
	"body": "<path opacity=\".3\" d=\"M6.26 9L12 13.47L17.74 9L12 4.53z\" fill=\"currentColor\"/><path d=\"M19.37 12.8l-7.38 5.74l-7.37-5.73L3 14.07l9 7l9-7zM12 2L3 9l1.63 1.27L12 16l7.36-5.73L21 9l-9-7zm0 11.47L6.26 9L12 4.53L17.74 9L12 13.47z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
